import * as React from 'react'
import { UseFormRegisterReturn } from 'react-hook-form'

import { cn } from '@/lib/utils/cn'

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          'flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Textarea.displayName = 'Textarea'

export interface TextareaDescriptionProps {
  id: string
  placeholder: string
  register?: UseFormRegisterReturn
  error?: string
  className?: string
  rows?: number
}

const TextareaDescription = React.forwardRef<HTMLTextAreaElement, TextareaDescriptionProps>(
  ({ id, placeholder, register, error, className, rows = 4, ...props }, ref) => {
    return (
      <div className="space-y-2">
        <textarea
          id={id}
          placeholder={placeholder}
          className={cn(
            'w-full min-h-[100px] px-3 py-2 rounded-md border border-input bg-background text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
            className
          )}
          rows={rows}
          ref={ref}
          {...register}
          {...props}
        />
        {error && <p className="text-sm text-destructive">{error}</p>}
      </div>
    )
  }
)
TextareaDescription.displayName = 'TextareaDescription'

export { Textarea, TextareaDescription }
